<template>
  <div id="inspire">
    <div class="backgroundWindow flex justify-center items-center p-0 h-screen px-4">
      <div class="bg-white card rounded-xl card_design w-full px-6 sm:px-12 py-4 sm:m-0">
        <div class="text-center flex flex-col items-center">
          <img src="@/assets/images/ZizbeyJobsLogo.svg" />
          <div class="heading-2 text-primary font-semibold pl-1">ZizbeyJobs</div>
          <div class="font-semibold heading-3 text-center text-text1 py-4">
            Verify OTP
          </div>

          <!-- Enter OTP -->
          <div class="mb-4 w-full">
            <p class="text-text1 mb-2">
              Enter the OTP sent to <span class="font-semibold">{{ mobileNumber }}</span>
            </p>

            <OtpInput
              ref="otpInput"
              v-model="otp"
              @otpComplete="handleOtpComplete"
            />
            <p class="text-error">{{ otpErr }}</p>

            <div class="flex justify-between items-center mt-2 mb-4">
              <span @click="goBack" class="cursor-pointer text-primary">
                <i class="fa-solid fa-arrow-left mr-1"></i> Back
              </span>
              <span v-if="countDown > 0" class="text-text2">Resend OTP in {{ countDown }}s</span>
              <span v-else @click="resendOtp" class="cursor-pointer text-primary">Resend OTP</span>
            </div>

            <div class="py-2 w-full">
              <Button
                class="flex text-center justify-center h-10 w-full"
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'primary'"
                :btnText="'Verify OTP'"
                :disabled="otp === '' || otp.length < 4"
                @buttonAction="verifyOtp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader
      v-if="$store.getters.showLoader"
      v-bind:data="$store.getters.loaderMessage"
    ></loader>
    <snakBar
      v-if="$store.getters.showAlert"
      v-bind:status="$store.getters.showAlert"
      v-bind:message="$store.getters.alertMessage"
      v-bind:color="$store.getters.alertColor"
    ></snakBar>
    <LoginConflictDialog
      v-if="showConflictDialog"
      @cancel="showConflictDialog = false"
      @forceLogin="handleForceLogin"
    />
  </div>
</template>

<script>
import Loader from '@/View/components/Loader.vue'
import snakBar from '@/View/components/SnakBar.vue'
import OtpInput from '@/View/components/OtpInput.vue'
import Button from '@/View/components/globalButton.vue'
import MyJobApp from '@/api/MyJobApp.js'
import {setCookiesWithExpire} from '@/utils/cookies.js'
import LoginConflictDialog from '@/View/login/components.vue/LoginConflictDialog.vue'

export default {
  name: 'OtpVerification',
  components: { Loader, snakBar, OtpInput, Button, LoginConflictDialog },
  data() {
    return {
      mobileNumber: '',
      registrationToken: '',
      otp: '',
      otpErr: '',
      countDown: 30,
      forceLogin: false,
      showConflictDialog: false
    }
  },
  mounted() {
    // Get mobile and token from query params
    this.mobileNumber = this.$route.query.mobile || '';
    this.registrationToken = this.$route.query.token || '';

    // Redirect back to login if no mobile number
    if (!this.mobileNumber) {
      this.$router.push({ name: 'login' });
      return;
    }

    this.startCountdown();
  },
  methods: {
    startCountdown() {
      this.countDown = 30;
      const timer = setInterval(() => {
        if (this.countDown > 0) this.countDown--;
        else clearInterval(timer);
      }, 1000);
    },
    goBack() {
      this.$router.push({ name: 'login' });
    },
    resendOtp() {
      this.$store.dispatch("SetLoader", { status: true, message: "Sending OTP..." });

      MyJobApp.SendOtp(
        this.mobileNumber,
        (response) => {
          this.registrationToken = response.Data;
          this.otp = '';
          this.otpErr = '';
          this.startCountdown();
          this.$store.dispatch('SetAlert', {showAlert: true, message: 'OTP sent successfully', color: 'success'});
          this.$store.dispatch('SetLoader', {status: false, message: ''});
        },
        (error) => {
          this.$store.dispatch('SetLoader', {status: false, message: ''});
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'});
        }
      );
    },
    handleOtpComplete(otp) {
      if (otp.length === 6) {
        this.verifyOtp(); // Auto-submit
      }
    },
    verifyOtp() {
      if (this.otp === '') {
        this.otpErr = 'Please enter OTP';
        return;
      }

      if (this.otp.length < 6) {
        this.otpErr = 'OTP must be at least 6 digits';
        return;
      }

      this.$store.dispatch("SetLoader", { status: true, message: "Verifying OTP..." });

      MyJobApp.VerifyMobileNo(
        this.mobileNumber,
        this.otp,
        this.registrationToken,
        this.forceLogin,
        (response) => {
          // ✅ Success handling (same as before)
          let latLong = {
            latitude: response.Data.organizationAddress.latitude,
            longitude: response.Data.organizationAddress.longitude
          };

          let LoginUserlatLong = null;
          if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                LoginUserlatLong = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude
                };
                localStorage.setItem('LoginUserlatLong', JSON.stringify(LoginUserlatLong));
              },
              (error) => console.error(`Geolocation error: ${error.message}`)
            );
          }

          localStorage.setItem('orgInfo', JSON.stringify(latLong));
          localStorage.setItem('jobUserInfo', JSON.stringify(response.Data.userInfo));
          setCookiesWithExpire('jobAuthToken', response.Data.userInfo.authToken, 30);
          
          this.$store.dispatch('SetAlert', {
            showAlert: true, 
            message: 'Logged in successfully', 
            color: 'success'
          });
          this.$store.dispatch('SetLoader', { status: false, message: '' });
          if (response.Data.redirectTo === "") {
            this.$router.push({ name: 'registerAsOwner' });
          } else if (response.Data.redirectTo === "employee" ||  response.Data.redirectTo === "admin") {
              this.$router.push({ name: 'dashboard1' });
          }
        },
        (error) => {
          this.$store.dispatch('SetLoader', { status: false, message: '' });
          if (error.message === '11200') {
            this.showConflictDialog = true;
            return;
          }
          this.otpErr = error.message;
          this.$refs.otpInput?.clear();
          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: error.message,
            color: 'error'
          });
        }
      );
    },
    handleForceLogin() {
      this.showConflictDialog = false;
      this.forceLogin = true;
      this.verifyOtp();
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Saira+Stencil+One&display=swap");
.backgroundWindow {
  background: url('../../assets/images/signup-in-background.jpg');
  background-size: cover;
  background-position: center;
}
.card_design {
  max-width: 500px;
}
</style>
